import ContentWrapper from "components/ContentWrapper";
import Header from "components/Header";
import Loader from "components/Loader";
import consts from "consts/consts";
import { getFromLocal } from "helpers/localStorage";
import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { TucanoActions, TucanoSelectors } from "web-api/main";

import style from "./style.module.css";

class PageCGU extends Component {
  componentDidMount() {
    const { t } = this.props;
    document.title = t(this.props.route.title);
    if (consts.appTitle) {
      document.title = `${consts.appTitle} - ${t(this.props.route.title)}`;
    }

    if (consts.appModules.faq !== true) {
      this.props.history.replace("/");
    }
    const languageId = getFromLocal("languageId");
    this.props.dispatch(TucanoActions.getFaq(languageId));
  }

  render() {
    const { isLoading, cgu } = this.props;

    return (
      <Fragment>
        <ContentWrapper>
          {isLoading && <Loader centered={true} />}
          {!isLoading && (
            <div className={style.root}>
              {cgu && (
                <div className={style.cguContainer}>
                  <Header rootClassName={style.header}>
                    {cgu.getQuestion()}
                  </Header>
                  <div
                    dangerouslySetInnerHTML={{ __html: cgu.getResponse() }}
                  />
                </div>
              )}
            </div>
          )}
        </ContentWrapper>
      </Fragment>
    );
  }
}

export default compose(
  connect((state) => {
    return {
      isLoading: state.reference.faq.loading,
      cgu: TucanoSelectors.getCguContent(state),
    };
  }),
  withTranslation()
)(PageCGU);
